<app-tabs>
    <app-tab [tabTextKey]="'pods-validation.tabs.pending.title'"
             [tabTextParams]="{nb: tabResultCount.pendingTotalCount}"
             [selected]="filters.podState == POD_STATE.PENDING"
             [navigate]="selectPendingTab">

            <div class="data-list-container">
                <div class="data-list-content">
                    <div  class="data-list-header" *ngIf="podsValidation && podsValidation.length !== 0">
                        <h3 [i18n]="'pods-validation.tabs.pending.header'"></h3>
                        <h3>
                            <span class="_txt-black" [i18n]="'pods-validation.tabs.pending.important-note'"></span>&nbsp;
                            <span [i18n]="'pods-validation.tabs.pending.cma-note'"></span>
                        </h3>
                    </div>
                    <app-pods-validation-list-item *ngFor="let podValidation of podsValidation; index as i; trackBy getPodValidationId"
                                                   [podValidation]="podValidation"
                                                   [displayedPod]="displayedPod"
                                                   (onPodRejected)="podRejected.emit(podValidation)"
                                                   (onPodValidated)="podValidated.emit(podValidation)"
                                                   (onDocumentUploaded)="podUploaded.emit(podValidation)"
                                                   (onPodClicked)="podSelected.emit(podValidation)"
                                                   (appendOriginGlidFilter)="appendOriginGlidFilter.emit($event)"
                                                   (appendDestinationGlidFilter)="appendDestinationGlidFilter.emit($event)"
                                                   class="data-list-item">
                    </app-pods-validation-list-item>

                    <div class="noResult" *ngIf="!podsValidation || podsValidation.length === 0">
                        <i class="fa fa-search"></i>
                        <span [i18n]="'pods-validation.tabs.pending.no-result'"></span>
                    </div>
                </div>

                <div class="data-list-footer" *ngIf="podsValidation && podsValidation.length > 0">
                    <app-ajax-pagination [page]="filters.page"
                                         [pageSize]="filters.pageSize"
                                         [lastPage]="lastPage"
                                         (pageChange)="onPageChange($event, filters.pageSize)">
                    </app-ajax-pagination>
                    <span class="inner-space-right-10 footer-control">
                        <select [ngModel]="filters.pageSize"
                                class="form-control size-select"
                                (ngModelChange)="onPageChange(1, $event)">
                            <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{size}}</option>
                        </select>
                        <span class="entries-count"
                              [i18n]="[{target: 'innerHTML', key: 'data-table.count', params: {count: tabResultCount.pendingTotalCount}}]">
                        </span>
                    </span>
                </div>
            </div>
    </app-tab>

    <app-tab [tabTextKey]="'pods-validation.tabs.review.title'"
             [tabTextParams]="{nb: tabResultCount.chepReviewTotalCount}"
             [selected]="filters.podState == POD_STATE.CHEP_REVIEW"
             [navigate]="selectReviewTab">

        <div class="data-list-container">
            <div class="data-list-content">
                <div  class="data-list-header" *ngIf="podsValidation && podsValidation.length !== 0">
                    <h3 [i18n]="'pods-validation.tabs.review.header'"></h3>
                </div>

                <app-pods-validation-list-item *ngFor="let podValidation of podsValidation; index as i; trackBy getPodValidationId"
                                               [podValidation]="podValidation"
                                               [displayedPod]="displayedPod"
                                               (onPodRejected)="podRejected.emit(podValidation)"
                                               (onPodValidated)="podValidated.emit(podValidation)"
                                               (onDocumentUploaded)="podUploaded.emit(podValidation)"
                                               (onPodClicked)="podSelected.emit(podValidation)"
                                               (appendOriginGlidFilter)="appendOriginGlidFilter.emit($event)"
                                               (appendDestinationGlidFilter)="appendDestinationGlidFilter.emit($event)"
                                               class="data-list-item">
                </app-pods-validation-list-item>

                <div class="noResult" *ngIf="!podsValidation || podsValidation.length === 0">
                    <i class="fa fa-search"></i>
                    <span [i18n]="'pods-validation.tabs.review.no-result'"></span>
                </div>
            </div>

            <div class="data-list-footer" *ngIf="podsValidation && podsValidation.length > 0">
                <app-ajax-pagination [page]="filters.page"
                                     [pageSize]="filters.pageSize"
                                     [lastPage]="lastPage"
                                     (pageChange)="onPageChange($event, filters.pageSize)">
                </app-ajax-pagination>
                <span class="inner-space-right-10 footer-control">
                    <select [(ngModel)]="filters.pageSize"
                            class="form-control size-select"
                            (ngModelChange)="onPageChange(1, $event)">
                        <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{size}}</option>
                    </select>
                    <span class="entries-count"
                          [i18n]="[{target: 'innerHTML', key: 'data-table.count', params: {count: tabResultCount.chepReviewTotalCount}}]">
                    </span>
                </span>
            </div>
        </div>
    </app-tab>

    <app-tab [tabTextKey]="'pods-validation.tabs.validated.title'"
             [tabTextParams]="{nb: tabResultCount.validatedTotalCount}"
             [selected]="filters.podState == POD_STATE.VALIDATED"
             [navigate]="selectValidationTab">

        <div class="data-list-container">
            <div class="data-list-content">
                <div  class="data-list-header" *ngIf="podsValidation && podsValidation.length !== 0">
                    <h3 [i18n]="'pods-validation.tabs.validated.header'"></h3>
                </div>

                <app-pods-validation-list-item *ngFor="let podValidation of podsValidation; index as i; trackBy getPodValidationId"
                                               [podValidation]="podValidation"
                                               [displayedPod]="displayedPod"
                                               (onPodRejected)="podRejected.emit(podValidation)"
                                               (onPodValidated)="podValidated.emit(podValidation)"
                                               (onDocumentUploaded)="podUploaded.emit(podValidation)"
                                               (onPodClicked)="podSelected.emit(podValidation)"
                                               (appendOriginGlidFilter)="appendOriginGlidFilter.emit($event)"
                                               (appendDestinationGlidFilter)="appendDestinationGlidFilter.emit($event)"
                                               class="data-list-item">
                </app-pods-validation-list-item>

                <div class="noResult" *ngIf="!podsValidation || podsValidation.length === 0">
                    <i class="fa fa-search"></i>
                    <span [i18n]="'pods-validation.tabs.validated.no-result'"></span>
                </div>
            </div>

            <div class="data-list-footer" *ngIf="podsValidation && podsValidation.length > 0">
                <app-ajax-pagination [page]="filters.page"
                                     [pageSize]="filters.pageSize"
                                     [lastPage]="lastPage"
                                     (pageChange)="onPageChange($event, filters.pageSize)">
                </app-ajax-pagination>
                <span class="inner-space-right-10 footer-control">
                    <select [(ngModel)]="filters.pageSize"
                            class="form-control size-select"
                            (ngModelChange)="onPageChange(1, $event)">
                        <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{size}}</option>
                    </select>
                    <span class="entries-count"
                          [i18n]="[{target: 'innerHTML', key: 'data-table.count', params: {count: tabResultCount.validatedTotalCount}}]">
                    </span>
                </span>
            </div>
        </div>
    </app-tab>
</app-tabs>
